import requestInfoAddress from "../utils/requestInfoAddress";

const getAll = async () => {
    try {
        const result = await requestInfoAddress.get(`/api/?depth=3&code=1`)
        return result.data
    } catch (error) {
        console.log(error);
    }
}

export {getAll}